import Captcha from './Captcha/Captcha';
import ClauseComponent from './Clauses/ClauseComponent';
import ClausesComponentVM from './Clauses/ClausesComponentVM';
import SingleClauseComponentVM from './Clauses/SingleClauseComponentVM';
import CreditCardExpiryDate from './CreditCardExpiryDate/CreditCardExpiryDate';
import Currency from './CurrencyField/CurrencyField';
import './CustomHTMLElement/CustomHTMLElement';
import CustomizedHeaderComponent from './CustomizedHeaderComponent/CustomizedHeaderComponent';
import FacebookShare from './FacebookShare/FacebookShare';
import FieldLinkComponent from './FieldLinkComponent/FieldLinkComponent';
import HelpIcon from './HelpIcon/HelpIcon';
import ImageComponent from './ImageComponent/ImageComponent';
import KnockOutPage from './KnockOutPageComponent/KnockOutPage';
import MediaSideBar from './MediaSidebarComponent/MediaSideBar';
import PaymentComponent from './PaymentComponent/PaymentComponent';
import PaymentList from './PaymentList/PaymentList';
import './platform-styles.scss';
import QuoteClauseTable from './QuoteClauseTable/QuoteClauseTable';
import ScheduleItemsComponent from './ScheduleItemsComponent/ScheduleItemsComponent';
import SuccessNotification from './SuccessNotification/SuccessNotification';
import TileComponent from './TileComponent/TileComponent';
import TypeAheadComponent from './TypeAheadComponent/TypeAheadComponent';
import UnderwritingIssues from './UnderwritingIssues/UnderwritingIssues';
import uwIssuesMessages from './UnderwritingIssues/UnderwritingIssues.messages';

const platformComponentMap = {
    ClauseComponent: { component: 'ClauseComponent' },
    ClausesComponentVM: { component: 'ClausesComponentVM' },
    CreditCardExpiryDate: { component: 'CreditCardExpiryDate' },
    FacebookShare: { component: 'FacebookShare' },
    fieldLinkComponent: { component: 'FieldLinkComponent' },
    ImageComponent: { component: 'ImageComponent' },
    link: { component: 'link' },
    mediaSidebar: { component: 'MediaSideBar' },
    PaymentList: { component: 'PaymentList' },
    QuoteClauseTable: { component: 'QuoteClauseTable' },
    ScheduleItemsComponent: { component: 'ScheduleItemsComponent' },
    CustomizedHeaderComponent: { component: 'CustomizedHeaderComponent' },
    SingleClauseComponentVM: { component: 'SingleClauseComponentVM' },
    TileComponent: { component: 'TileComponent' },
    TypeAheadComponent: { component: 'TypeAheadComponent' },
    PaymentComponent: { component: 'PaymentComponent' },
    UnderwritingIssues: { component: 'UnderwritingIssues' },
    SuccessNotification: { component: 'SuccessNotification' },
    // override both to preserve consistency for metadata usage
    Currency: { component: 'Currency' },
    currency: { component: 'currency' },
    Captcha: { component: 'Captcha' },
};

const platformComponents = {
    ClauseComponent,
    ClausesComponentVM,
    CreditCardExpiryDate,
    FacebookShare,
    FieldLinkComponent,
    ImageComponent,
    MediaSideBar,
    PaymentList,
    QuoteClauseTable,
    ScheduleItemsComponent,
    CustomizedHeaderComponent,
    SingleClauseComponentVM,
    TileComponent,
    TypeAheadComponent,
    PaymentComponent,
    UnderwritingIssues,
    SuccessNotification,
    Captcha,
    // override both to preserve consistency for metadata usage
    Currency,
    currency: Currency,
};

export {
    ClauseComponent,
    ClausesComponentVM,
    CreditCardExpiryDate,
    FacebookShare,
    FieldLinkComponent,
    ImageComponent,
    MediaSideBar,
    PaymentList,
    SingleClauseComponentVM,
    TileComponent,
    TypeAheadComponent,
    CustomizedHeaderComponent,
    PaymentComponent,
    Currency,
    KnockOutPage,
    UnderwritingIssues,
    SuccessNotification,
    Captcha,
    // for Jutro
    platformComponentMap,
    platformComponents,
    // messages
    uwIssuesMessages,
    HelpIcon,
};
